import { ChangeDetectionStrategy, Component, computed, model, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonDirective, injectModal, ModalStepperComponent } from '@fnccr-actee/design-system';
import { TranslatePipe } from '@ngx-translate/core';
import { OnboardingStepFourComponent } from './steps/onboarding-step-four/onboarding-step-four.component';
import { OnboardingStepOneComponent } from './steps/onboarding-step-one/onboarding-step-one.component';
import { OnboardingStepThreeComponent } from './steps/onboarding-step-three/onboarding-step-three.component';
import { OnboardingStepTwoComponent } from './steps/onboarding-step-two/onboarding-step-two.component';

@Component({
  selector: 'app-onboarding',
  imports: [
    ModalStepperComponent,
    FormsModule,
    OnboardingStepOneComponent,
    OnboardingStepTwoComponent,
    OnboardingStepThreeComponent,
    OnboardingStepFourComponent,
    TranslatePipe,
    ButtonDirective,
  ],
  templateUrl: './onboarding-popup.component.html',
  styleUrl: './onboarding-popup.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'app-onboarding',
  },
  encapsulation: ViewEncapsulation.None,
})
export class OnboardingPopupComponent {
  private readonly _modal = injectModal();

  readonly totalSteps = 4;

  readonly currentStep = model<number>(1);
  readonly isLastStep = computed(() => this.currentStep() === this.totalSteps);
  readonly isFirstStep = computed(() => this.currentStep() === 1);

  skipOnboardingTutorial(): void {
    this._modal.close({ value: { hideForever: true } });
  }

  completeOnboardingTutorial(): void {
    this._modal.close({ value: { hideForever: true } });
  }

  goToPreviousSlide(): void {
    if (this.currentStep() > 1) {
      this.currentStep.update((step) => step - 1);
    }
  }

  goToNextSlide(): void {
    if (this.currentStep() < this.totalSteps) {
      this.currentStep.update((step) => step + 1);
    }
  }
}
